
import { WorkoutsRepository } from "../../infra/repository/workout.repository";
import { Workout } from "../domain/workout";

export class CreateWorkoutUseCase {
    static async execute(action: Workout): Promise<{ id: string }> {
        try {
            const response = await WorkoutsRepository.create(action);
            if (response.error) {
                throw Error("Erro ao criar treino");
            }
            return response.data;
        } catch (error) {        
            throw Error("Erro ao criar treino");
        }
    }
}